export default __webpack_public_path__ + "static/media/link-linked_blue.5f0458cd.svg";